import { useMemo, useState, useEffect } from 'react';
import { commonTranslations, Language, defaultLanguage, loadPageTranslation } from '../../locales';

const getNestedValue = (obj: any, path: string): any => {
  const value = path.split('.').reduce((current, key) => current?.[key], obj);
  return value || path;
};

// Cache pour les traductions de Home
const homeTranslationsCache: Record<string, any> = {};

/**
 * Hook de traduction pour les traductions communes et Home
 * Pour les traductions spécifiques à une page, utilisez usePageTranslation
 * @deprecated Pour les nouvelles pages, utilisez usePageTranslation avec la section appropriée
 */
export const useTranslation = (lang: Language = defaultLanguage) => {
  const [homeTranslations, setHomeTranslations] = useState<any>({});

  // Charger les traductions de Home si nécessaire
  useEffect(() => {
    const loadHome = async () => {
      const cacheKey = lang;
      if (!homeTranslationsCache[cacheKey]) {
        try {
          const homeTrans = await loadPageTranslation(lang, 'public', 'Home');
          homeTranslationsCache[cacheKey] = homeTrans;
          setHomeTranslations(homeTrans);
        } catch (error) {
          console.warn('Failed to load Home translations:', error);
          setHomeTranslations({});
        }
      } else {
        setHomeTranslations(homeTranslationsCache[cacheKey]);
      }
    };
    loadHome();
  }, [lang]);

  const t = useMemo(() => {
    // Fusionner les traductions communes et Home
    const common = commonTranslations[lang] || commonTranslations[defaultLanguage];
    const merged = { ...common, ...homeTranslations };
    
    return (key: string): any => {
      return getNestedValue(merged, key);
    };
  }, [lang, homeTranslations]);

  return { t, currentLang: lang };
};

export default useTranslation;
